<div class="generalPage" aria-label="StandardtypeAcronym" role="main">
  <div class="pr-22 content-container pb-0">
    <h1 class="sub-heading margin-0 content-blue itcHeavyFont" tabindex="0">{{st_header}}</h1>
    <p class="answer font-16 content-blue width-100" id="st_description" [innerHTML]="st_description" tabindex="0"></p>
    <div class="standardtype-table answer font-16  content-blue width-100">
      <ul class="standardtype-table-ul  font-16">
        <li class="standardtype-row" *ngFor="let subheader of st_acronymsheaderdisplay;let i = index" [ngClass]="{'width-110' : i==0}" tabindex="0"><strong>{{subheader}}</strong></li>
      </ul>

    </div>
    <p class="topic-heading font-16 content-blue bold" id="st_acronymheader" [innerHTML]="st_acronymheader">

    </p>
    <div class="standardtype-table answer font-16 content-blue width-100 mb-2">
      <ul class="standardtype-table-ul" *ngFor="let st of st_acronymsdisplay">
        <li class="width-110 standardtype-row">{{st.key}}</li>
        <li class="standardtype-row">{{st.value}}</li>
      </ul>

    </div>
    <p class="answer font-16 content-blue width-100 mt-2" id="st_acronymdescription" [innerHTML]="st_acronymdescription" appHostListenerClick tabindex="0"></p>
  </div>
  </div>
